export const TipoComprobanteMovimientoConstants = {
  ENTRADA: "ENTRA",
  SALIDA: "SALIDA",
  TRASLADO: "TRASLA",
  REMOVER: "REMOVE",
  ANULADO: "ANULAD",
};

const routesUsuario = {
  modulos: "seguridad/modulos/",
  rutas: "seguridad/rutas/",
  perfiles: "seguridad/perfiles/",
};
const routesEntidades = {
  personas: "entidades/personas/",
  contactos: "entidades/contactos/",
  clientes: "entidades/clientes/",
};
const routesConfiguraciones = {
  empresas: "configuraciones/empresas/",
  centrocostos: "configuraciones/centrocostos/",
  notificaciones: "configuraciones/notificaciones/",
};
const PATH_DIRECTOS = {
  puntoventa: "/pos/puntoventa",
  caja: "/cajas/caja/",
  arqueocaja: "/cajas/arqueocaja/",
};

export { routesUsuario, routesEntidades, routesConfiguraciones, PATH_DIRECTOS };
